module.exports = __webpack_public_path__ + "img/Importation-image-01.3e475c75.jpg";